//Get login User Details
export const FETCH_BLOCK_LISTING_SUCCESS = 'FETCH_BLOCK_LISTING_SUCCESS';
export const FETCH_BLOCK_LISTING_FAILURE = 'FETCH_BLOCK_LISTING_FAILURE';

export const RESET = 'RESET';
